<div class="list-page kapea" style="max-width: 1200px">
  <h2>Asiakkaan lähettämillä laskuilla näkyvät tiedot</h2>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding: 10px; margin-bottom: 20px; max-width: 600px; position: relative" class="mat-elevation-z2">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Laskuasetukset: <a [href]="laskutusprofiilitEncodedUriObservable | async" target="_BLANK">{{ laskutusprofiilitUriObservable | async }}</a>
      </div>
    </div>
  }

  <!-- <button class="secondarybutton" mat-button (click)="asetaTervetuloaDialoginNakyvyys()">Muuta tervetuloadialogin näyttäminen</button> -->

  <div style="padding: 2em">
    @if (!ladattu()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (laskutusprofiilitObservable | async; as laskutusprofiilit) {
      @if (laskutusprofiilit.length > 1) {
        <mat-button-toggle-group class="segmentti" [value]="(valittuLaskutusprofiiliObservable | async)?.avain" (change)="valitseLaskutusprofiili($event.value)" [hideSingleSelectionIndicator]="true">
          @for (laskutusprofiili of laskutusprofiilit; track laskutusprofiili.avain) {
            <mat-button-toggle [value]="laskutusprofiili.avain">{{ laskutusprofiili.nimi }}</mat-button-toggle>
          }
        </mat-button-toggle-group>
      }
    }
    @if (valittuLaskutusprofiiliObservable | async; as laskutusprofiili) {
      <div class="laskutusprofiili">
        <div class="profiilin-otsikko">
          <div class="profiilin-nimi">{{ laskutusprofiili.nimi }}</div>
          @if (laskutusprofiili.oletusprofiili) {
            <span class="oletusprofiili">Oletusprofiili</span>
          }
        </div>

        <div class="osiot">
          <div class="osio">
            <div class="osion-otsikko">
              <mat-icon class="osion-ikoni">business</mat-icon>
              {{ 'asetukset.yrityksen-tiedot' | translate | async }}
            </div>
            <div class="alaotsikko">{{ 'laskuasetukset.laskuttaja' | translate | async }}</div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.yrityksen-nimi' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.nimi || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.y-tunnus' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.ytunnus || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.katuosoite' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.katuosoite || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.postinro' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.postinro || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.postitoimipaikka' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.postitmp || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.maa' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.maakoodi | lmaa | async }}</span>
            </div>
            <div class="alaotsikko">{{ 'laskuasetukset.asiakaspalvelun-yhteystiedot-laskulla' | translate | async }}</div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.sahkoposti' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.replyto || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.puhelinnumero' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.puhelin || '–' }}</span>
            </div>
          </div>

          <div class="osio">
            <div class="osion-otsikko">
              <mat-icon class="osion-ikoni">palette</mat-icon>
              {{ 'asetukset.laskun-ulkoasu' | translate | async }}
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.logo.otsikko' | translate | async }}</span>
              <span class="arvo">
                @if (laskutusprofiili.asetukset.base64Logo) {
                  <img class="logo" [src]="laskutusprofiili.logo" [alt]="'laskuasetukset.logo.otsikko' | translate | async" />
                } @else {
                  –
                }
              </span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.piilota-yrityksen-nimi-laskulta' | translate | async }}</span>
              <span
                ><span class="tila" [class.tila-paalla]="laskutusprofiili.asetukset.piilotaYrityksenNimiLaskulla">{{ laskutusprofiili.asetukset.piilotaYrityksenNimiLaskulla ? 'Kyllä' : 'Ei' }}</span></span
              >
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.vapaamuotoinen-teksti' | translate | async }}</span>
              <span class="arvo monirivinen">{{ laskutusprofiili.asetukset.ohjeet || '–' }}</span>
            </div>
          </div>

          <div class="osio">
            <div class="osion-otsikko">
              <mat-icon class="osion-ikoni">account_balance</mat-icon>
              {{ 'asetukset.maksutilit' | translate | async }}
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.iban' | translate | async }}</span>
              <span class="arvo tilinumero">{{ laskutusprofiili.asetukset.iban || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.pankki' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.pankki || '–' }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.bic' | translate | async }}</span>
              <span class="arvo tilinumero">{{ laskutusprofiili.asetukset.bic || '–' }}</span>
            </div>
          </div>

          <div class="osio">
            <div class="osion-otsikko">
              <mat-icon class="osion-ikoni">tune</mat-icon>
              {{ 'asetukset.laskutuksen-oletukset' | translate | async }}
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.oletusmaksuehto' | translate | async }}</span>
              <span class="arvo">{{ laskutusprofiili.oletusmaksuehto }} {{ 'lasku.pv-netto' | translate | async }}</span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.verottoman-myynnin-oletusperuste' | translate | async }}</span>
              <span class="arvo">
                @if (laskutusprofiili.asetukset.verottomanMyynninOletusperuste) {
                  {{ 'verottoman-myynnin-peruste.' + laskutusprofiili.asetukset.verottomanMyynninOletusperuste | translate | async }}
                } @else {
                  {{ 'laskuasetukset.ei-oletusta' | translate | async }}
                }
              </span>
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.kuuluu-alv-rekisteriin' | translate | async }}</span>
              <span
                ><span class="tila" [class.tila-paalla]="(alvRekisterinTilaAvainObservable | async) === 'laskuasetukset.alv-rekisteri-kylla'">{{ alvRekisterinTilaAvainObservable | async | translate | async }}</span></span
              >
            </div>
            @if (alvRekisterissaObservable | async) {
              <div class="tieto">
                <span class="tiedon-nimi">{{ 'laskuasetukset.laskurivien-hinnat-verollisina' | translate | async }}</span>
                <span
                  ><span class="tila" [class.tila-paalla]="laskutusprofiili.asetukset.laskurivienHinnatVerollisina">{{ laskutusprofiili.asetukset.laskurivienHinnatVerollisina ? 'Kyllä' : 'Ei' }}</span></span
                >
              </div>
            }
          </div>

          <div class="osio">
            <div class="osion-otsikko">
              <mat-icon class="osion-ikoni">sync_alt</mat-icon>
              {{ 'asetukset.reskontra' | translate | async }}
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">{{ 'laskuasetukset.automaattinen-reskontra' | translate | async }}</span>
              <span
                ><span class="tila" [class.tila-paalla]="laskutusprofiili.asetukset.maksupReskontraActive">{{ laskutusprofiili.asetukset.maksupReskontraActive ? 'Kyllä' : 'Ei' }}</span></span
              >
            </div>
          </div>

          <div class="osio">
            <div class="osion-otsikko">
              <mat-icon class="osion-ikoni">info</mat-icon>
              Muut tiedot
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">Summahuomautus piilotettu</span>
              <span
                ><span class="tila" [class.tila-paalla]="laskutusprofiili.asetukset.summahuomautusPiilotettu">{{ laskutusprofiili.asetukset.summahuomautusPiilotettu ? 'Kyllä' : 'Ei' }}</span></span
              >
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">Tervetuloa nähty</span>
              <span
                ><span class="tila" [class.tila-paalla]="laskutusprofiili.asetukset.tervetuloaNahty">{{ laskutusprofiili.asetukset.tervetuloaNahty ? 'Kyllä' : 'Ei' }}</span></span
              >
            </div>
            <div class="tieto">
              <span class="tiedon-nimi">Muokattu</span>
              <span class="arvo">{{ laskutusprofiili.asetukset.date | ltimestamp | async }}</span>
            </div>
          </div>
        </div>

        <mat-accordion class="spostipohjat-paneeli">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="osion-ikoni">mail</mat-icon>
                {{ 'asetukset.spostipohja' | translate | async }}
              </mat-panel-title>
              <mat-panel-description>{{ laskutusprofiili.spostipohjat.length }} pohjaa</mat-panel-description>
            </mat-expansion-panel-header>
            <div class="spostipohjat">
              @for (spostipohja of laskutusprofiili.spostipohjat; track $index) {
                <div class="spostipohja">
                  <div class="spostipohjan-otsikko">
                    {{ spostipohja.pohjanNimenAvain | translate | async }}
                    <span class="kieli">{{ spostipohja.asetukset.kieli }}</span>
                  </div>
                  <div class="tieto">
                    <span class="tiedon-nimi">{{ 'laskuasetukset.aihe' | translate | async }}</span>
                    <span class="arvo">{{ spostipohja.asetukset.aihe || '–' }}</span>
                  </div>
                  <div class="tieto">
                    <span class="tiedon-nimi">{{ 'laskuasetukset.otsikko' | translate | async }}</span>
                    <span class="arvo">{{ spostipohja.asetukset.otsikko || '–' }}</span>
                  </div>
                  <div class="tieto">
                    <span class="tiedon-nimi">{{ 'laskuasetukset.teksti' | translate | async }}</span>
                    <span class="arvo monirivinen">{{ spostipohja.asetukset.teksti || '–' }}</span>
                  </div>
                </div>
              }
              <div class="spostipohja">
                <div class="spostipohjan-otsikko">{{ 'laskuasetukset.yleiset' | translate | async }}</div>
                <div class="tieto">
                  <span class="tiedon-nimi">{{ 'laskuasetukset.slogan' | translate | async }}</span>
                  <span class="arvo monirivinen">{{ laskutusprofiili.asetukset.slogan || '–' }}</span>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    }
  </div>
</div>
